import template from "./move-cost-modal.html";

const MoveCostModalComponent = {
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
  template: template,
  controller: class MoveCostModalController {
    /* @ngInject */
    constructor($rootScope, $filter, CostFolder, Cost, ModalsManager, Notification) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.CostFolder = CostFolder;
      this.Cost = Cost;
      this.ModalsManager = ModalsManager;
      this.NotificationService = Notification;
    }

    async $onInit() {
      this.costFolderOrCost = this.resolve.costFolderOrCost;
      this.rootFolder = {
        _id: null,
        name: this.$filter("trans")("costFolder.main"),
      };
      this.parentCostFolder = this.rootFolder;
      this.folders = [];
      this.loading = true;
      const costFolders = await this.CostFolder.queryByParent(null);
      this.folders = costFolders.filter((costFolder) => costFolder._id !== this.costFolderOrCost._id);
      this.loading = false;
    }

    async loadCostFolder(parentCostFolderId) {
      this.loading = true;
      if (parentCostFolderId) {
        this.parentCostFolder = await this.CostFolder.get(parentCostFolderId);
        const costFolders = await this.CostFolder.queryByParent(parentCostFolderId);
        this.folders = this._removeParentFolder(costFolders);
      } else {
        this.parentCostFolder = this.rootFolder;
        this.folders = await this.CostFolder.queryByParent(null);
      }
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async previous() {
      if (this.parentCostFolder.ancestors === null || this.parentCostFolder.ancestors.length === 0) {
        await this.loadCostFolder(null);
      } else {
        const ancestorsLength = this.parentCostFolder.ancestors.length;
        const previousAncestor = this.parentCostFolder.ancestors[ancestorsLength - 1];
        await this.loadCostFolder(previousAncestor._id);
      }
    }

    async createCostFolder() {
      if (await this.ModalsManager.openCostFolderModal(new this.CostFolder({ parent: this.parentCostFolder._id }))) {
        await this.loadCostFolder(this.parentCostFolder._id);
      }
    }

    async move() {
      this.loading = true;
      await this.costFolderOrCost.move(this.parentCostFolder._id);
      this.loading = false;
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.costMoved"),
      });
      this.close({ $value: true });
      this.$rootScope.$applyAsync();
    }

    _removeParentFolder(costFolders) {
      return costFolders.filter((costFolder) => {
        if (this.costFolderOrCost.parent && this.costFolderOrCost.parent._id === costFolder._id) return false;
        else if (costFolder._id === this.costFolderOrCost._id) return false;
        else return true;
      });
    }
  },
};

export default MoveCostModalComponent;
